import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import InfoPopupContainer from './container/InfoPopupContainer';

interface IRetryChatGPTPopup {
  isShow: boolean;
  onClose: () => void;
}

const RetryChatGPTPopup = ({ isShow, onClose }: IRetryChatGPTPopup) => {
  const { t } = useTranslation();

  if (!isShow) {
    return null;
  }

  return (
    <InfoPopupContainer title={t('chat_popup_title_network_error')}>
      <div css={buttonContainer}>
        <p className="message"> {t('chat_popup_label_chatgtp_error')}</p>
        <button className="button" onClick={onClose}>
          {t('common_popup_button_retry')}
        </button>
      </div>
    </InfoPopupContainer>
  );
};

const buttonContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1em;

  .message {
    color: ${theme.colors.gray700};
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    letter-spacing: -0.0187rem;
    white-space: pre-line;
  }

  .button {
    margin-top: 1.25rem;
    width: 100%;
    height: 52px;
    background: #b91732;
    color: ${theme.colors.white};
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.375rem;
    letter-spacing: -0.0187rem;
    border-radius: 0.5rem;
  }
`;

export default RetryChatGPTPopup;
